import React from 'react';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { getClsData } from '../../../../../services/api';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Topic extends React.PureComponent {
    state = { topic: '' };

    /**
     * 请求 Topic
     */
    componentDidMount() {
        this.getData();

        this.timer = setInterval(() => {
            this.getData();
        }, 30000);
    }

    /**
     * 卸载定时器
     */
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    getData = async () => {
        try {
            const data = await getClsData(Date.parse(new Date()));

            if (data.data && data.data.length > 0) {
                this.setState({
                    topic: data.data[0].brief,
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    createMarkup = () => {
        const { topic } = this.state;

        return { __html: topic };
    };

    /**
     * 渲染组件
     */
    render() {
        const { topic } = this.state;

        return (
            <div className={styles.zhibo}>
                <a href="//finance.ifeng.com/studio" target="_blank" rel={rel} title={topic}>
                    <span dangerouslySetInnerHTML={this.createMarkup()} />
                </a>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Topic.propTypes = {};

/**
 * 定义组件默认属性
 * */
Topic.defaultProps = {};

export default errorBoundary(Topic);
